"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotEyeOff = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotEyeOff = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M19.964 17.097c3.372 2.678 7.728 4.856 12.65 4.57 12.856-.714 5.25-16.191-.808-19.57-3.95-2.2-9.449-2.913-14.027-.95a9.813 9.813 0 0 0-2.307 1.43c-1.821.2-3.657 1.485-3.457 3.463.443 4.321 4.4 8.235 7.95 11.057Z",
    opacity: 0.75
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M16.501 7.067a15.2 15.2 0 0 1 3.5-.4C31.668 6.667 38.335 20 38.335 20a30.83 30.83 0 0 1-3.6 5.317m-11.2-1.783a5 5 0 1 1-7.067-7.067m-14.8-14.8 36.667 36.667M29.9 29.9a16.784 16.784 0 0 1-9.9 3.434C8.335 33.334 1.668 20 1.668 20a30.751 30.751 0 0 1 8.433-9.9l19.8 19.8Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotEyeOff = SpotEyeOff;
SpotEyeOff.displayName = "SpotEyeOff";